module.exports = __webpack_public_path__ + "static/media/gray_animal_reptiles.4720c405.webp";